/* eslint-disable import/prefer-default-export */
import * as ReduxHelpers from '@src/utils/reduxHelpers'
const prefix = 'cam/filter'

//Action Types
export const APPLY_NOW = ReduxHelpers.Types.createActionType(
  prefix,
  'APPLY_NOW'
)
export const RESET_ALL = ReduxHelpers.Types.createActionType(
  prefix,
  'RESET_ALL'
)
